var slider = document.getElementById("myRange");
let slider_value = document.getElementById("slider_value");
let submit_size_btn = document.getElementById("submit_size");
slider_value.innerHTML = slider.value; // Display the default slider value

let wrapper = document.getElementById("FacetsWrapperDesktop");
let size_filter = wrapper.getElementsByTagName("details")[1];

// Update the current slider value (each time you drag the slider handle)
slider.oninput = function () {
  slider_value.innerHTML = this.value;
};

// XS  === ...-164 [0]
// S   === 164-172 [1]
// M   === 173-179 [2]
// L   === 180-186 [3]
// XL  === 187-195 [4]
// XXL === 196-... [5]

let basic_size = sessionStorage.getItem("basic_size");
if (basic_size) {
  slider.value = basic_size;
  slider_value.innerHTML = basic_size;
}

submit_size_btn.addEventListener("click", () => {
  console.log("Clicked Button");
  const x = slider.value;
  sessionStorage.setItem("basic_size", x);
  switch (true) {
    case x <= 164:
      console.log("XS");
      window.location.href = "?filter.p.m.custom.groesse=XS+%28bis+164cm%29";
      break;
    case x <= 172:
      console.log("S");
      window.location.href = "?filter.p.m.custom.groesse=S+%28164+-+172%29";
      break;
    case x <= 179:
      console.log("M");
      window.location.href = "?filter.p.m.custom.groesse=M+%28173+-+179%29";
      break;
    case x <= 186:
      console.log("L");
      window.location.href = "?filter.p.m.custom.groesse=L+%28180+-+186%29";
      break;
    case x <= 195:
      console.log("XL");
      window.location.href = "?filter.p.m.custom.groesse=XL+%28187+-+195%29";
      break;
    case x >= 195:
      console.log("XXL");
      window.location.href = "?filter.p.m.custom.groesse=XXL+%28ab+196%29";
      break;
  }
});

/* ---------------------------------------------------------------------------------------------- */

// first_size = size_filter
//   .getElementsByTagName("li")[0]
//   .getElementsByTagName("input");

// // trigger the first element
// size_filter
//   .getElementsByTagName("li")[0]
//   .getElementsByTagName("input")[0]
//   .click();

// // trigger the second element
// size_filter
//   .getElementsByTagName("li")[1]
//   .getElementsByTagName("input")[0]
//   .click();
